import { ConnectionLineComponentProps, getStraightPath } from '@xyflow/react';

import './CustomConnectionLine.css';

export function CustomConnectionLine({ fromX, fromY, toX, toY }: ConnectionLineComponentProps) {
  const [edgePath] = getStraightPath({
    sourceX: fromX,
    sourceY: fromY,
    targetX: toX,
    targetY: toY,
  });

  return (
    <g>
      <path
        fill="none"
        stroke="#b1b1b7"
        strokeWidth={2}
        d={edgePath}
        style={{
          strokeDasharray: '5,5',
          animation: 'dashdraw 0.5s linear infinite',
        }}
      />
      <circle cx={toX} cy={toY} fill="#b1b1b7" r={3} stroke="#fff" strokeWidth={1.5} />
    </g>
  );
}
